import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Dashboard.css'
import image1 from '../../images/c1.png'
import image2 from '../../images/c2.png'
import image3 from '../../images/c3.png'
import image4 from '../../images/c4.png'
import { getCustomerGroup } from '../../service/customerService';
import { toPersian } from 'persian';
import priceFormat from '../../service/showPriceFormat';
import { genSpecificDateTime } from '../../util/dateTime';
import toast from 'react-hot-toast';


const Dashboard = () => {
    let navigate = useNavigate();
    const { state } = useLocation();
    const [groups, setGroups] = useState({ active: 0, near: 0, deActive: 0 })
    const [smsPanel, setSmsPanel] = useState({ smsBalance: '', allocatedSmsBalance: '', remainSmsBalance: '', smsPlan: '', smsExpireDate: '' })

    useEffect(() => {
        if (!state || !state.person) {
            return navigate("/", { replace: true });
        }
        const fetchAllProducts = async () => {
            try {

                let { status, data } = await getCustomerGroup(state.person);
                if (status === 201) {
                    setGroups(data.groupCount);
                    if(!data.smsInfo.errorMsg){
                        setSmsPanel(data.smsInfo);
                    }
                    else{
                        toast.error(data.smsInfo.errorMsg.replace('Error:', 'خطای پنل پیامکی:'), {style:{ direction: 'rtl', textAlign:'right'}})
                    }
                }
            } catch (err) {
            }
        }

        fetchAllProducts();


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (!state || !state.person) {
        return navigate("/", { replace: true });
    }

    return (
        <React.Fragment>
            <div className='d-flex justify-content-center flex-wrap rtl mt-2'>
                <div className='alert alert-dark mx-1' style={{ fontSize: '.8rem' }}>
                    <span>اعتبار پنل پیامکی :</span>
                    <span className='ml-2'>{smsPanel.smsBalance ? toPersian(priceFormat(smsPanel.smsBalance)) : '---'} ریال</span>
                </div>
                <div className='alert alert-primary mx-1' style={{ fontSize: '.8rem' }}>
                    <span>اختصاص داده شده :</span>
                    <span className='ml-2'>{smsPanel.allocatedSmsBalance ? toPersian(priceFormat(smsPanel.allocatedSmsBalance)) : '---'} ریال</span>
                </div>
                <div className={` alert mx-1 ${Number(smsPanel.remainSmsBalance) > 0 ? 'alert-success' : 'alert-danger' }`} style={{ fontSize: '.8rem' }}>
                    <span>باقیمانده :</span>
                    <span className='mx-2 d-inline-block ltr'> {smsPanel.remainSmsBalance ? toPersian(priceFormat(smsPanel.remainSmsBalance)) : '---'}</span>ریال
                </div>
                <div className='alert alert-warning mx-1' style={{ fontSize: '.8rem' }}>
                    <span>نوع پنل :</span>
                    <span className='ml-2'>{smsPanel.smsPlan ? toPersian(smsPanel.smsPlan) : '---'}</span>
                </div>
                <div className='alert alert-info mx-1 ' style={{ fontSize: '.8rem' }}>
                    <span>تاریخ انقضا :</span>
                    <span className='ml-2 d-inline-block ltr'>{smsPanel.smsExpireDate ? toPersian(genSpecificDateTime(new Date(smsPanel.smsExpireDate), 'jYYYY/jMM/jDD HH:mm').dateTimeStr) : '---'}</span>
                </div>
            </div>
            <h5 className='text-center text-muted font-weight-bold mt-3'>« مشتریان »</h5>
            <div className='dashboard-layer'>
                <div>
                    <div className='button-dashboard' onClick={() => navigate('/dashboard/archive', { state: { ...state, type: 'active' } })}>
                        <img src={image1} alt="" />
                        <span>فعال</span>
                        <section>
                            <h5>
                                <span className='badge badge-success badge-pill badge'>{groups.active}</span>
                            </h5>
                        </section>
                    </div>
                    <div className='button-dashboard' onClick={() => navigate('/dashboard/archive', { state: { ...state, type: 'near' } })}>
                        <img src={image2} alt="" />
                        <span>نزدیک تمدید</span>
                        <section>
                            <h5>
                                <span className='badge badge-warning badge-pill'>{groups.near}</span>
                            </h5>
                        </section>
                    </div>
                    <div className='button-dashboard' onClick={() => navigate('/dashboard/archive', { state: { ...state, type: 'deActive' } })}>
                        <img src={image3} alt="" />
                        <span>غیرفعال</span>
                        <section>
                            <h5>
                                <span className='badge badge-danger badge-pill'>{groups.deActive}</span>
                            </h5>
                        </section>
                    </div>
                    <div className='button-dashboard' onClick={() => navigate('/dashboard/create-customer', { state: state })}>
                        <img src={image4} alt="" />
                        <span>افزودن</span>
                        <section>
                            <h5>
                                <span className='badge badge-success badge-pill badge'><i className='fa fa-pencil'></i></span>
                            </h5>
                        </section>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Dashboard;